export class MPAInterceptedResponseMpaPolicies {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policies",
            "baseName": "policies",
            "type": "Array<MPAPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAInterceptedResponseMpaPolicies.attributeTypeMap;
    }
    constructor() {
    }
}
